var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "xr-create",
    {
      attrs: { loading: _vm.loading, title: _vm.title },
      on: { close: _vm.close, save: _vm.saveClick },
    },
    [
      _c(
        "create-sections",
        { attrs: { title: "基本信息" } },
        [
          _c(
            "el-form",
            {
              ref: "crmForm",
              staticClass: "wk-form",
              attrs: {
                model: _vm.fieldForm,
                rules: _vm.fieldRules,
                "validate-on-rule-change": false,
                "label-position": "top",
              },
            },
            _vm._l(_vm.fieldList, function (children, index) {
              return _c("wk-form-items", {
                key: index,
                attrs: { "field-from": _vm.fieldForm, "field-list": children },
                on: { change: _vm.formChange },
              })
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }